import React from "react";
import { UsersIcon, BellIcon } from "@heroicons/react/24/solid";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import profile from "../../assets/uicon.png";
import { Link } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';


const DashboardHeader = ({ image }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="bg-[#060409]/60 lg:h-20 sticky top-0 py-4">
      <div className="h-full flex items-center px-5">
        <div className="flex-1">
          <MagnifyingGlassIcon className="w-6 h-6 text-gray-700 hidden" />
        </div>
        <div className="flex space-x-4">
          <UsersIcon className="w-7 h-7 mt-3 text-white/75" />
          <BellIcon className="w-7 h-7 mt-3 text-white/75" />
          <Tooltip title="profile">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "DashboardHeader" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              {image ? (
                <img
                  src={image}
                  alt="profile"
                  className="w-7 h-7 rounded-full"
                />
              ) : (
                <img src={profile} alt="profile" className="w-7 h-7" />
              )}
            </IconButton>
          </Tooltip>
        </div>
        <Menu
          anchorEl={anchorEl}
          id="DashboardHeader"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleClose}>
            <Link to="/dashboard/useradmin">Profile</Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <Link to="/">Logout</Link>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default DashboardHeader;
